var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIphone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.909,
    height: 20,
    viewBox: "0 0 10.909 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iphone_Outline",
    transform: "translate(-0.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M8.95,0H2.3A2.129,2.129,0,0,0,.168,2.127V17.873A2.129,2.129,0,0,0,2.3,20H8.95a2.13,2.13,0,0,0,2.127-2.127V2.127A2.13,2.13,0,0,0,8.95,0Zm1.218,17.873A1.219,1.219,0,0,1,8.95,19.091H2.3a1.219,1.219,0,0,1-1.218-1.218V2.127A1.219,1.219,0,0,1,2.3.909H8.95a1.219,1.219,0,0,1,1.218,1.218Zm0,0",
    fill: "#7b818e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M88.682,42.668H85.955a.455.455,0,1,0,0,.909h2.727a.455.455,0,0,0,0-.909Zm-.455,15.454a.909.909,0,1,1-.909-.909A.909.909,0,0,1,88.227,58.122Zm0,0",
    transform: "translate(-81.696 -40.85)",
    fill: "#7b818e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIphone);
export default __webpack_public_path__ + "static/media/iphone.f299c3096a330bbc3e9dfdb9f807b4a3.svg";
export { ForwardRef as ReactComponent };